import { Container, Image } from "react-bootstrap";
import Header from "../components/header";
import { Button } from "../components/styles/SmbButton.styled";
import { useEffect, useState } from "react";
import { fetchSmbTrackId } from "../api/smb";
import {
  PageWrapper,
  TopSection,
  TopSectionMain,
  Slider,
  SliderBox,
  BestRateSection,
  BestRateSlider,
  RateSliderBox,
  SectionContent,
  PartnerSection,
  ProgramSection,
  ProgramSectionContent,
  SectionImg,
  SectionRow,
} from "../components/styles/SmbLoadingPage.styled";
import { ValidateAddress } from "../ValidateAddressSmb";
import GetStartedModal from "../components/smb/GetStartedModal";

const SmbLandingPage = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("smbGetQuote")) {
      setShowModal(true);
      sessionStorage.removeItem("smbGetQuote");
    }

    const getTrackId = async () => {
      const trackId = await fetchSmbTrackId();
      if (trackId?.response?.TrackId) {
        sessionStorage.setItem("smbTrackId", trackId.response.TrackId);
      }
    };

    const storedTrackId = sessionStorage.getItem("smbTrackId");
    if (!storedTrackId) {
      getTrackId();
    }
  }, []);

  const SliderData = [
    {
      title: "Step 1",
      description: "Instant quotes from top suppliers",
      icon: <img src="/images/icons_payment-01.svg" alt="step1" />,
    },
    {
      title: "Step 2",
      description: "No upfront costs or hidden fees",
      icon: <img src="/images/icons_payment-02.svg" alt="step2" />,
    },
    {
      title: "Step 3",
      description: "Trusted partnerships with licensed providers",
      icon: <img src="/images/icons_payment-03.svg" alt="step3" />,
    },
    {
      title: "Step 4",
      description: "Mobile-friendly access and digital signing",
      icon: <img src="/images/icons_payment-04.svg" alt="step4" />,
    },
  ]

  const RateSliderData = [
    {
      title: "Real-Time Access",
      description: "Instantly view live electricity rates from top-tier suppliers in your area. Our system continuously updates pricing to ensure you see the most current offers available.",
      icon: <img src="/images/icon-rate-1.png" alt="step1" width={312} />,
    },
    {
      title: "Transparent Pricing",
      description: "See the exact rates and contract terms before you commit. No surprises, no hidden fees, no complicated pricing structures.",
      icon: <img src="/images/icon-rate-2.png" alt="step2" width={384} />,
    },
    {
      title: "Tailored Solutions",
      description: "We match plans based on your usage profile and location, ensuring you get the most suitable energy solution for your specific business needs.",
      icon: <img src="/images/icon-rate-3.png" alt="step3" width={371} />,
    },
    {
      title: "Same-Day Signing",
      description: "Secure and digitally sign your preferred contract within minutes. Our streamlined process gets you enrolled quickly without service interruptions.",
      icon: <img src="/images/icon-rate-4.png" alt="step4" width={408} />,
    },
  ]

  return (
    <>
      <Header />
      <PageWrapper>
        <Container>
          <TopSection>
            <TopSectionMain>
              <h1>Find The Best Commercial Energy Rates in Texas</h1>
              <p>
                Compare real-time commercial electricity rates and plans in minutes
              </p>
              <div style={{ maxWidth: '560px',width:'100%' }}><ValidateAddress onsubmit={()=>{setShowModal(true)}}/></div>
            </TopSectionMain>
            <Slider>
              {SliderData.map((item, index) => (
                <SliderBox key={index}>
                  {item.icon}
                  {item.description}
                </SliderBox>
              ))}
            </Slider>
          </TopSection>
        </Container>
      </PageWrapper>
      <BestRateSection>
        <Container>
          <h3>Too many plans?</h3>
          <h2>The Best Rate for Your <br /> Business — Always</h2>
          <div className="line"></div>
          <p style={{ margin: '40px 0' }}>We update rates daily to give your business the best deal <br /> based on real market data</p>
          <BestRateSlider>
            {RateSliderData.map((item, index) => (
              <RateSliderBox key={index}>
                <div className="text-box">
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>
                <div className="icon-box">{item.icon}</div>
              </RateSliderBox>
            ))}
          </BestRateSlider>
        </Container>
      </BestRateSection>

      <ProgramSection>
        <Container>
          <h4>Get Started</h4>
          <h3>
            Simple 3-Step Process
          </h3>
          <div className="line"></div>
          <SectionRow reverse>
            <ProgramSectionContent>
              <p className="step-title">Step 1</p>
              <h2>Share Your Business Info</h2>
              <p>
                Enter your business details and energy usage information to get personalized quotes from top energy providers in your area.
              </p>
            </ProgramSectionContent>
            <SectionImg>
              <img src="/images/step1.png" alt="" />
            </SectionImg>
          </SectionRow>
          <SectionRow>
            <ProgramSectionContent>
              <p className="step-title">Step 2</p>
              <h2>Compare & Choose</h2>
              <p>
                View real-time competitive rates and plans tailored to your business needs. Compare options with complete transparency and no hidden fees.
              </p>
            </ProgramSectionContent>
            <SectionImg>
              <img src="/images/smbstep2.png" alt="" />
            </SectionImg>
          </SectionRow>
          <SectionRow style={{ marginBottom: "0" }} reverse>
            <ProgramSectionContent>
              <p className="step-title">Step 3</p>
              <h2>Sign & Switch</h2>
              <p>
                Digitally sign your chosen plan in minutes using our secure platform. We handle all the switching details with no service interruptions.
              </p>
            </ProgramSectionContent>
            <SectionImg>
              <img src="/images/smbstep3.png" alt="" />
            </SectionImg>
          </SectionRow>
        </Container>
      </ProgramSection>
      <GetStartedModal
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
    </>
  );
};

export default SmbLandingPage;
